// extracted by mini-css-extract-plugin
export default {"rowGroup":"TnackOBZJyeEQTofoUx7","tab":"x3_BvyBdJg5ckWYqq84g"};